<template>
  <button
      :disabled="isDisabled"
      @click.stop="makeOutboundCall"
      v-bind:class="customClass"
  >
    <slot>
      <i class="fas fa-phone-alt"></i>
    </slot>
  </button>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  props: {
    conversation: Object,
    customClass: String,
  },

  computed: {
    ...mapGetters('voice', [
      'isStatusReady',
    ]),

    /**
     * @return {boolean}
     */
    isDisabled() {
      return (! this.isStatusReady) || _.get(this.$attrs, 'disabled', false);
    },
  },

  methods: {
    ...mapActions('voice', [
      'connect',
    ]),

    /**
     * @return {undefined}
     */
    makeOutboundCall() {
      this.connect({conversation: this.conversation});
    },
  },
}
</script>
